export const USER_ID_HEADER_KEY = 'COUNTR-USERID';
export const TOKEN_HEADER_KEY = 'COUNTR-TOKEN';
export const EMAIL_HEADER_KEY = 'COUNTR-EMAIL';
export const DISPLAY_NAME_HEADER_KEY = 'COUNTR-DISPLAY-NAME';
export const ROLES_HEADER_KEY = 'COUNTR-ROLES';
export const CHOSEN_LANGUAGE = 'COUNTR-CHOSEN-LANGUAGE';
export const OWN_ORGANISATIONS_AND_SITES = 'COUNTR-OWN-ORGANISATION_AND_SITES';
export const DASHBOARD_FILTER_DATA = 'COUNTR-DASHBOARD-FILTER-DATA';
export const STATISTICS_FILTER_DATA = 'COUNTR-STATISTICS-FILTER-DATA';
export const LIVE_VIEW_FILTER_DATA = 'COUNTR-LIVE-VIEW-FILTER-DATA';
export const SETTINGS_FILTER_DATA = 'COUNTR-SETTINGS-FILTER-DATA';

export const userRoles = {
  superAdmin: "SUPER_ADMIN",
  organisationAdmin: "ORG_ADMIN",
  regionalManager: "REGIONAL_MANAGER",
  siteManager: "SITE_MANAGER",
  viewer: "VIEWER"
}

export enum Role {
  SUPER_ADMIN = 'SUPER_ADMIN',
  ORG_ADMIN = 'ORG_ADMIN',
  REGIONAL_MANAGER = 'REGIONAL_MANAGER',
  SITE_MANAGER = 'SITE_MANAGER',
  VIEWER = 'VIEWER'
}

export const ROLE_HIERARCHY: Record<Role, number> = {
  [Role.SUPER_ADMIN]: 5,
  [Role.ORG_ADMIN]: 4,
  [Role.REGIONAL_MANAGER]: 3,
  [Role.SITE_MANAGER]: 2,
  [Role.VIEWER]: 1
};

export const ROLES_LIST = [
  Role.SUPER_ADMIN,
  Role.ORG_ADMIN,
  Role.REGIONAL_MANAGER,
  Role.SITE_MANAGER,
  Role.VIEWER
];

export const colors = {
  primary: "#1E283D",
  secondary: "#C09133",
  blue:  "#4DA1A9",
  green: "#3F8F6B",
  red: "#C85A5A",
  grey: "#AAB2BD",
  white: "#FFFFFF",
}

export const supportedLanguages = ['en'];

export const toastrConfig = { progressBar: true, closeButton: true, timeOut: 5000 }

export const filterStartYear = 2010;
export const counterChartMaxData = 120;
export const dashboardChartConfig = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: true
    },
    tooltip: {
      enabled: true
    }
  },
  scales: {
    x: {
      grid: {
        drawOnChartArea: false,
        drawTicks: false,
        drawBorder: false
      }
    }
  }
};

export const timeIntervals = ['5MIN', '10MIN', '15MIN', 'HOUR', 'DAY', 'WEEK', 'MONTH', 'YEAR'];
export const ageGroups = ['14-19', '25-34', '35-44', '45-54', '55-64', '65+'];
export const genders = ['female', 'male'];
export const visitorTypes = ['all', 'new', 'returning '];
